import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container page-frame" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col container prepayment-overview" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = {
  key: 0,
  class: "my-3"
}
const _hoisted_15 = { class: "row justify-content-center" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "row justify-content-between mb-2" }
const _hoisted_18 = { class: "row table-wrap" }
const _hoisted_19 = { class: "col table table-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_ApplyPrepaymentDialog = _resolveComponent("ApplyPrepaymentDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumbs, {
        here: '前払い申し込み',
        ancestries: _ctx.ancestries
      }, null, 8, ["ancestries"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "col h2",
          style: _normalizeStyle({ fontSize: _ctx.FontSizes.large1})
        }, _toDisplayString(_ctx.staff.userName) + "さんの前払い申し込みページ", 5)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "col h3",
          style: _normalizeStyle({ fontSize: _ctx.FontSizes.large1})
        }, _toDisplayString(_ctx.prepaymentMonthText) + "の前払い", 5)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-6" }, "報酬合計額", -1)),
            _createElementVNode("div", _hoisted_7, "¥" + _toDisplayString(_ctx.amountToString(_ctx.compensationSum)), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-6" }, "前払い可能上限額", -1)),
            _createElementVNode("div", _hoisted_9, "¥" + _toDisplayString(_ctx.amountToString(_ctx.compensationSum * 0.8)), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-6" }, "前払い済み金額", -1)),
            _createElementVNode("div", _hoisted_11, "¥" + _toDisplayString(_ctx.amountToString(_ctx.prepaidSum)), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-6" }, "前払い可能残高", -1)),
            _createElementVNode("div", _hoisted_13, "¥" + _toDisplayString(_ctx.amountToString(_ctx.prepaymentBalance)), 1)
          ])
        ])
      ]),
      (_ctx.showPrepaymentUI())
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row justify-content-center" }, [
              _createElementVNode("p", null, "1000円単位でお申込みができます")
            ], -1)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: _normalizeClass(["col-8 btn", _ctx.canMakePrepayment() ? 'btn-success' :'btn-danger']),
                disabled: !_ctx.canMakePrepayment(),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickApplyPrepayment && _ctx.onClickApplyPrepayment(...args)))
              }, _toDisplayString(_ctx.makePrepaymentButtonText()), 11, _hoisted_16)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          class: "col-8 col-md-6 h4 align-self-center",
          style: _normalizeStyle({ fontSize: _ctx.FontSizes.large1})
        }, _toDisplayString(_ctx.recordTableMonthText) + "の報酬と前払いの履歴", 5),
        (_ctx.authStore.getters.authLevel !== _ctx.authLevels.DIST_STAFF)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              class: "month-select col-4 col-md-2 align-self-center",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.backwardMonthCountText) = $event))
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("option", { value: "0" }, "今月", -1),
              _createElementVNode("option", { value: "1" }, "前月", -1)
            ]))], 512)), [
              [_vModelSelect, _ctx.backwardMonthCountText]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("table", _hoisted_19, [
          _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { style: {"width":"20%"} }, "日付"),
              _createElementVNode("th", { style: {"width":"40%"} }, "摘要"),
              _createElementVNode("th", { style: {"width":"30%"} }, "金額")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dailyRecords, (record) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: record.vForKey,
                class: _normalizeClass({'table-info': !record.isAvailableForPrepayment})
              }, [
                _createElementVNode("td", null, _toDisplayString(record.formattedDate), 1),
                _createElementVNode("td", null, _toDisplayString(record.description), 1),
                _createElementVNode("td", null, "¥" + _toDisplayString(record.amountString), 1)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_ApplyPrepaymentDialog, {
        show: _ctx.showSubmitDialog,
        close: _ctx.onRequestCloseApplyDialog,
        "prepayment-balance": _ctx.prepaymentBalance,
        "staff-id": _ctx.staffId,
        "on-finish-submit-prepayment": _ctx.onFinishSubmitPrepayment
      }, null, 8, ["show", "close", "prepayment-balance", "staff-id", "on-finish-submit-prepayment"])
    ]))
  ], 64))
}